import { BILLING_TYPE } from '@schuettflix/interfaces';

export const BILLING_TYPE_LABEL = {
    CREDIT_NOTE: 'organization.billingMethod.creditNote',
    INVOICE: 'organization.billingMethod.invoice',
    PARTNER_INVOICE: 'organization.billingMethod.partnerInvoice',
} as const satisfies Record<BILLING_TYPE, string>;
